import { create } from 'zustand';

import type { AssistantMessage, Message, UserMessage } from '@/chat/types';

interface ChatStore {
  messages: Message[];
  appendTurn: (user: UserMessage, assistant: AssistantMessage) => void;
  updateAssistant: (id: string, patch: Partial<AssistantMessage>) => void;
  reset: () => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  messages: [],
  appendTurn: (user, assistant) =>
    set((state) => ({ messages: [...state.messages, user, assistant] })),
  // 리셋 이후 늦게 완료된 요청이 빈 스토어를 갱신하지 않도록 없는 id는 무시
  updateAssistant: (id, patch) =>
    set((state) => ({
      messages: state.messages.map((message) =>
        message.id === id && message.role === 'assistant' ? { ...message, ...patch } : message
      ),
    })),
  reset: () => set({ messages: [] }),
}));

export const selectHasActiveTurn = (state: { messages: Message[] }): boolean =>
  state.messages.some(
    (message) =>
      message.role === 'assistant' &&
      (message.status === 'uploading' || message.status === 'analyzing')
  );
